import React, { Component } from "react";
import Loader from 'react-loader-spinner'
import { checkTranslation, translate } from "../../utils/useful";

class AddUserHome extends Component {

  state = {
    // isLoadingRemove: false,
    // id: null,
    // index: null,
    // image: '',
    options: [
      { key: 'search', title: '{{lang}}Search hub', description: 'Find a hub using name or usename and send invitation for them.', icon: '/assets/icons/useful/search.png' },
      { key: 'qr', title: '{{lang}}Scan QR code', description: 'Find a hub using QR code and send invitation for them.', icon: '/assets/icons/useful/scan.png' },
      // { key: 'link', title: '{{lang}}Code Link', description: '', icon: '/images/url.svg' },
      { key: 'form', title: '{{lang}}Create Virtual User', description: 'Virtual hubs can be used for the conditions that you want to use a hub in frame, but they are not part of Yonnect yet. So you can create a virtual hub and any time later assign it to a real hub if you want.', icon: '/assets/icons/useful/ghost (3).png' },
    ]
  }

  // images=["001-man.svg",'011-woman.svg','012-woman.svg','019-man.svg','022-man.svg','025-man.svg','027-woman.svg','033-woman.svg','035-man.svg','038-man.svg','042-man.svg','043-woman.svg','049-woman.svg','050-woman.svg']

  componentDidMount() {
    // this.props.setTitle('Invite User')
    // this.changeImage()
    //  this.interval = setInterval(() => {
    //   this.changeImage()
    // }, 1500);
  }


  componentWillUnmount() {
    clearInterval(this.interval)
  }

  changeImage = () => {
    let number = Math.floor(Math.random() * this.images.length - 1)
    if (this.images[number]) {
      let image = this.images[number]
      this.setState({ image })
    }
  }

  // hideModal = () => {
  //   this.removeModal.hideModal()
  // }

  changeStage = (key) => {
    if (key == 'form') {
      this.props.setData(null)
    }
    this.props.changePage(key)
  }

  render() {
    return (
      <div className="" style={{}}>
        <div className='flexcb  position-sticky top-0 w-100' style={{ padding: '12px 14px', zIndex: 2, borderBottom: '1px solid #f0f0f0' }}>
          <div className='flexc' style={{}}>
            {/* {this.state.backbtn == true &&
              <button onClick={this.BackStage}>
                <img width={18} className='mrd-2 flexcc ' src='/assets/icons/arrow-left-white.svg' />
              </button>
            } */}
            <p className='text-normal text-bold' style={{}}>{translate('Invite or create')}</p>
          </div>
          {/* {this.state.backbtn == true &&
            <ButtonAnimated
              iconwidth='24px'
              onClick={this.state.isLoadingPost ? () => { } : () => this.nextBtn()}
              title={translate('Submit')}
              icon='/assets/icons/plus-white.svg'
              textColor={this.props.colors?.iconInvert ? '#fff' : '#000'}
              invert={!this.props.colors?.iconInvert}
              bg={this.props.colors?.iconInvert ? '#000' : '#fff'}
              isLoading={this.state.isLoadingPost}
            />
          } */}

        </div>
        {/* <div className="flexc py-3 px-3 " style={{ background: this.props.colors?.background ?? 'linear-gradient(to  left , #677dc4, #877cc4)', position: 'sticky', top: 0, zIndex: 1 }}>
          <p className="text-bold text-normal px-1 white">{translate("Invite User")}</p>
        </div> */}
        <div className="flexcc flex-column mt-2 px-0 mb-2 ">
          {this.state.options.map((prop, index) => {
            return (
              <button onClick={() => this.changeStage(prop.key)} className="py-1 px-2 w-100 bb-gray">
                <div className="hover-gray br-6 p-2 flexc w-100 text-start">
                  {/* <div className=" p-2 flexcc" style={{ width: 30, height: 30, alignSelf: 'stretch', background: this.props.colors?.background ?? 'linear-gradient(to  left , #677dc4, #877cc4)', borderRadius: '30px', }}> */}
                  < img src={prop.icon} alt="" height="30px" />
                  {/* </div> */}
                  <div className="pld-5">
                    <p className="text-small text-bold p-0" >{checkTranslation(prop.title)}</p>
                    <p className="font-size-12 pt-1" style={{ color: '#777' }}>{translate(prop.description)}</p>
                  </div>
                </div>
              </button>
            )

          })

          }
          {/* <button onClick={()=>this.props.onDone('groups')} className="m-1 p-3 px-4    w-100"  style={{ boxShadow:'inset 0 0 10px #eee',background:'linear-gradient(to left bottom,#f2f6f8,#eee)',borderRadius:8 }}>
              <img className="" src={'/images/networking.png'} alt="" height="50px" />
              <p className="text-normal  text-bold mt-2 p-0 text-uppercase" style={{  lineHeight: 1, textAlign: 'center', }}>{translate("groups")}</p>
              <p className="text-smaller   mt-1 p-0" style={{  lineHeight: 1, textAlign: 'center', }}>{translate('new access for one or more groups')}</p>
            </button> */}
        </div >

        <p className="pt-3  px-3 font-size-12 pb-3 mx-2 mt-0 br-6" style={{ backgroundColor: '#f4f4f4', color: '#444' }}>{translate("You-can-invite-users-to-your-account")}</p>

        {/* <p className="pt-3  px-3 text-smaller pb-3 mt-2" style={{ color: '#789',backgroundColor:'#f2f6f8', borderRadius: '0px 0px 8px 8px' }}>{translate("Consider terms and policies will inviting users")}</p> */}

      </div >

    );
  }
}



export default AddUserHome;
